import axios from "axios";
import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部ETフォーム-チャットアプリ連携-依存選択肢一覧取得
export async function getOutsideEntryFormChatAppDependSelects(id: string) {
  try {
    const path = "outsideEntryFormChatAppDependSelects";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
  }
}

// 外部ETフォーム-チャットアプリ連携-依存選択肢詳細取得
export async function getOutsideEntryFormChatAppDependSelect(id: string) {
  try {
    const path = "outsideEntryFormChatAppDependSelect";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    if (response.data.detail_data && response.data.detail_data.length > 0) {
      return response.data.detail_data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
}

// 外部ETフォーム-チャットアプリ連携-依存選択肢編集
export async function putOutsideEntryFormChatAppDependSelect(editData: EditDataDifine) {
  try {
    const path = "outsideEntryFormChatAppDependSelect";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, { params, bodys });
    return response.data.edit;
  } catch (error) {
    return undefined;
  }
}

// 外部ETフォーム-チャットアプリ連携-依存選択肢登録
export async function postOutsideEntryFormChatAppDependSelect(addData: {
  [key: string]: string | number | boolean | unknown[];
}) {
  try {
    const path = "outsideEntryFormChatAppDependSelect";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, { bodys });
    return response.data.add;
  } catch (error) {
    return undefined;
  }
}

// 外部ETフォーム-チャットアプリ連携-依存選択肢削除
export async function deleteOutsideEntryFormChatAppDependSelect(id: string) {
  try {
    const path = "outsideEntryFormChatAppDependSelect";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, { params });
    return response.data.delete;
  } catch (error) {
    return undefined;
  }
}

// 外部ETフォーム-質問・選択肢一覧（依存追加モーダル用）
export async function getOutsideEntryFormOptionsForChatAppDepend(outsideEntryFormId: string) {
  try {
    const path = "outsideEntryFormOptionsForChatAppDepend";
    const params = { id: outsideEntryFormId };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    return response.data.fetch_data || [];
  } catch (error) {
    return [];
  }
}
